import React from 'react';

export const Section = ({ id, label, title, lede, children, dark, dense }) => (
  <section id={id} className={`section ${dark ? 'section--dark' : ''} ${dense ? 'section--dense' : ''}`} data-screen-label={id}>
    <div className="container">
      {label && <div className="section__label">{label}</div>}
      {title && <h2 className="section__title">{title}</h2>}
      {lede && <p className="section__lede">{lede}</p>}
      {children}
    </div>
  </section>
);

export const ThreeUp = () => {
  const items = [
    {
      n: '01',
      title: 'CRM with AI built in.',
      body: 'A leads board with native AI enrichment, ICP scoring, and outreach drafting. Stop stitching a CRM, a research tool, and a sequencer.',
      tag: 'Lead pipeline',
    },
    {
      n: '02',
      title: 'Triggers that replace Zapier.',
      body: 'Build flows visually inside a column. AI agents, webhooks, JS sandboxes, scheduled jobs — all on the same board.',
      tag: 'AI automation',
    },
    {
      n: '03',
      title: 'Voice and chat, in the board.',
      body: 'Click a card, open a huddle. Threads attach to tasks. AI listens and proposes work — you approve.',
      tag: 'Collab',
    },
  ];
  return (
    <div className="threeup">
      {items.map((it) => (
        <article key={it.n} className="threeup__item">
          <div className="threeup__num">{it.n}</div>
          <div className="threeup__tag">{it.tag}</div>
          <h3 className="threeup__title">{it.title}</h3>
          <p className="threeup__body">{it.body}</p>
        </article>
      ))}
    </div>
  );
};

export const MultiView = () => {
  const [view, setView] = React.useState('columns');
  const views = ['columns', 'swimlanes', 'sprint', 'table'];

  return (
    <div className="multiview">
      <div className="multiview__tabs">
        {views.map(v => (
          <button
            key={v}
            onClick={() => setView(v)}
            className={`multiview__tab ${view === v ? 'is-active' : ''}`}
          >{v}</button>
        ))}
      </div>
      <div className="multiview__stage">
        {view === 'columns' && <MVColumns />}
        {view === 'swimlanes' && <MVSwimlanes />}
        {view === 'sprint' && <MVSprint />}
        {view === 'table' && <MVTable />}
      </div>
    </div>
  );
};

const mvCard = (label, dot) => (
  <div className="mv-card" style={{ fontSize: '16.5px' }}>
    <span className="mv-card__dot" style={{ background: dot }} />
    {label}
  </div>
);

const MVColumns = () => (
  <div className="mv-columns">
    {[
      { t: 'Backlog', cards: [['Refactor billing webhook', '#737373'], ['Migrate auth to passkeys', '#737373'], ['Audit log compaction', '#737373']] },
      { t: 'In progress', cards: [['Voice huddle MVP', '#C78A05'], ['Apollo enrichment cache', '#C78A05']] },
      { t: 'Review', cards: [['Sprint burndown widget', '#7b1fa2']] },
      { t: 'Shipped', cards: [['Lead enrichment agent', '#1b5e20'], ['EU data residency v2', '#1b5e20']] },
    ].map((col, i) => (
      <div key={i} className="mv-col">
        <div className="mv-col__head">{col.t} <span>{col.cards.length}</span></div>
        {col.cards.map(([l, d], j) => <React.Fragment key={j}>{mvCard(l, d)}</React.Fragment>)}
      </div>
    ))}
  </div>
);

const MVSwimlanes = () => (
  <div className="mv-swim">
    {[
      { lane: 'Anya / sales', items: [['Lyra AB — proposal', '#C78A05'], ['Northwind — discovery', '#737373']] },
      { lane: 'Karim / eng', items: [['Voice huddle MVP', '#C78A05'], ['Audit log compaction', '#737373']] },
      { lane: 'Saskia / ops', items: [['EU data residency v2', '#1b5e20']] },
    ].map((row, i) => (
      <div key={i} className="mv-swim__row">
        <div className="mv-swim__label">{row.lane}</div>
        <div className="mv-swim__items">{row.items.map(([l,d], k) => <React.Fragment key={k}>{mvCard(l, d)}</React.Fragment>)}</div>
      </div>
    ))}
  </div>
);

const MVSprint = () => (
  <div className="mv-sprint">
    <div className="mv-sprint__head">
      <div>
        <div className="mv-sprint__title">Sprint 24 · Week 2 of 2</div>
        <div className="mv-sprint__sub">Capacity 184h · Logged 142h · Remaining 42h</div>
      </div>
      <div className="mv-sprint__stats">
        <div><strong>72%</strong><span>Velocity</span></div>
        <div><strong>3.4d</strong><span>Cycle</span></div>
        <div><strong>0</strong><span>Blockers</span></div>
      </div>
    </div>
    <div className="mv-burndown">
      <svg viewBox="0 0 400 80" preserveAspectRatio="none" width="100%" height="80">
        <line x1="0" y1="10" x2="400" y2="70" stroke="#EBEBEB" strokeWidth="1" strokeDasharray="3 3" />
        <polyline points="0,10 50,18 100,22 150,32 200,38 250,48 300,55 340,58 400,62" fill="none" stroke="#0A0A0A" strokeWidth="1.5" />
        <circle cx="340" cy="58" r="3" fill="#C78A05" />
      </svg>
    </div>
  </div>
);

const MVTable = () => (
  <div className="mv-table">
    <div className="mv-table__head">
      <span>Task</span><span>Assignee</span><span>Status</span><span>Est</span><span>Logged</span>
    </div>
    {[
      ['Voice huddle MVP', 'Karim', 'In progress', '12h', '8h'],
      ['Apollo enrichment cache', 'Karim', 'In progress', '6h', '4h'],
      ['Sprint burndown widget', 'Anya', 'Review', '4h', '5h'],
      ['Lead enrichment agent', 'Saskia', 'Shipped', '16h', '14h'],
      ['EU data residency v2', 'Saskia', 'Shipped', '20h', '22h'],
    ].map((row, i) => (
      <div key={i} className="mv-table__row">
        {row.map((c, j) => <span key={j}>{c}</span>)}
      </div>
    ))}
  </div>
);

const AGENT_PROMPT = "When a new lead arrives, enrich it, score it, and draft outreach";
const AGENT_STEPS = [
  {
    when: 'WHEN',
    title: 'A new lead is added',
    sub: 'Trigger from form, email, API, or board',
    chips: ['lead.created'],
    icon: '◐',
  },
  {
    when: 'THEN',
    title: 'Enrich with AI',
    sub: 'Pull company, headcount, funding, tech-stack, hiring signals',
    chips: ['company', 'headcount', 'stack', 'signals'],
    icon: '◑',
  },
  {
    when: 'THEN',
    title: 'Score ICP fit & route',
    sub: 'Agent assigns 0–100 and moves the card to the right column',
    route: [
      ['≥ 75', 'Outreach (priority)', '#1b5e20'],
      ['40–74', 'Nurture queue', '#C78A05'],
      ['< 40', 'Disqualified', '#737373'],
    ],
    icon: '◒',
  },
  {
    when: 'THEN',
    title: 'Draft personalized outreach',
    sub: 'Opener attached to card · waits for human approval before sending',
    chips: ['gpt-eu', 'mistral-large', 'human-approve'],
    icon: '◓',
  },
];

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const AgentsDiagram = () => {
  const reduced = prefersReducedMotion();
  const [phase, setPhase] = React.useState(reduced ? 'done' : 'idle');
  const [typed, setTyped] = React.useState(reduced ? AGENT_PROMPT : '');
  const [stepIdx, setStepIdx] = React.useState(reduced ? AGENT_STEPS.length - 1 : -1);

  React.useEffect(() => {
    if (reduced) return;
    let timer;
    let alive = true;

    function run() {
      if (!alive) return;
      setPhase('typing');
      setTyped('');
      setStepIdx(-1);

      let i = 0;
      const type = () => {
        if (!alive) return;
        i++;
        setTyped(AGENT_PROMPT.slice(0, i));
        if (i < AGENT_PROMPT.length) {
          timer = setTimeout(type, 28);
        } else {
          timer = setTimeout(() => {
            if (!alive) return;
            setPhase('building');
            buildSteps(0);
          }, 600);
        }
      };
      type();
    }

    function buildSteps(i) {
      if (!alive) return;
      setStepIdx(i);
      if (i < AGENT_STEPS.length - 1) {
        timer = setTimeout(() => buildSteps(i + 1), 700);
      } else {
        timer = setTimeout(() => {
          if (!alive) return;
          setPhase('done');
          timer = setTimeout(run, 5000);
        }, 1200);
      }
    }

    run();
    return () => { alive = false; clearTimeout(timer); };
  }, [reduced]);

  const replay = () => {
    if (reduced) return;
    setPhase('typing');
    setTyped('');
    setStepIdx(-1);
    let i = 0;
    const type = () => {
      i++;
      setTyped(AGENT_PROMPT.slice(0, i));
      if (i < AGENT_PROMPT.length) setTimeout(type, 28);
      else setTimeout(() => {
        setPhase('building');
        let s = 0;
        const next = () => {
          setStepIdx(s);
          if (s < AGENT_STEPS.length - 1) { s++; setTimeout(next, 700); }
          else setTimeout(() => setPhase('done'), 1000);
        };
        next();
      }, 500);
    };
    type();
  };

  return (
    <div className="agent-builder">
      <div className="agent-builder__chrome">
        <div className="agent-builder__tab">
          <span className="agent-builder__tab-icon">⚡</span>
          flow builder
        </div>
        <div className="agent-builder__breadcrumb">
          <span>Sales board</span> <span className="agent-builder__sep">/</span> <span>Automations</span> <span className="agent-builder__sep">/</span> <span>New flow</span>
        </div>
        <button className="agent-builder__replay" onClick={replay} type="button">↻ replay</button>
      </div>

      <div className="agent-builder__body">
        <div className="agent-builder__prompt">
          <div className="agent-builder__prompt-label">
            <span className="agent-builder__sparkle">✦</span>
            describe your flow
          </div>
          <div className="agent-builder__prompt-input">
            <span className="agent-builder__prompt-text">
              {typed}
              {phase === 'typing' && <span className="agent-builder__cursor" />}
            </span>
          </div>
          {phase !== 'idle' && phase !== 'typing' && (
            <div className="agent-builder__assist">
              <span className="agent-builder__assist-dot" />
              {phase === 'building' ? 'Assembling steps…' : `Flow ready · ${AGENT_STEPS.length} steps`}
            </div>
          )}
        </div>

        <div className="agent-builder__canvas">
          {AGENT_STEPS.map((step, i) => {
            const visible = i <= stepIdx;
            const active = i === stepIdx && phase === 'building';
            return (
              <React.Fragment key={i}>
                <div className={`agent-step ${visible ? 'is-visible' : ''} ${active ? 'is-active' : ''}`}>
                  <div className="agent-step__rail">
                    <div className="agent-step__icon">{step.icon}</div>
                    <div className="agent-step__num">{step.when}</div>
                  </div>
                  <div className="agent-step__card">
                    <div className="agent-step__title">{step.title}</div>
                    <div className="agent-step__sub">{step.sub}</div>
                    {step.chips && (
                      <div className="agent-step__chips">
                        {step.chips.map(c => <span key={c}>{c}</span>)}
                      </div>
                    )}
                    {step.route && (
                      <div className="agent-step__route">
                        {step.route.map(([cond, dest, color]) => (
                          <div key={cond}>
                            <span className="agent-step__dot" style={{ background: color }} />
                            <code>{cond}</code> → {dest}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {i < AGENT_STEPS.length - 1 && (
                  <div className={`agent-connector ${i < stepIdx ? 'is-visible' : ''}`}>
                    <div className="agent-connector__line" />
                  </div>
                )}
              </React.Fragment>
            );
          })}
          {phase === 'done' && (
            <div className="agent-publish">
              <div className="agent-publish__check">✓</div>
              <div>
                <div className="agent-publish__title">Flow saved &amp; live</div>
                <div className="agent-publish__sub">Running on every new lead · sandboxed in your tenant</div>
              </div>
              <button className="agent-publish__btn">Open in workspace →</button>
            </div>
          )}
        </div>
      </div>

      <div className="agent-builder__foot">
        <span>Trigger from a column · chat · webhook · cron</span>
        <span>Sandboxed K8s · gVisor · network allowlist</span>
        <span>Bring-your-own LLM</span>
      </div>
    </div>
  );
};

const ENRICH_ROWS = [
  { label: 'Headcount', value: '140 · Series B' },
  { label: 'Stack', value: 'Postgres · Kubernetes · Stripe' },
  { label: 'Signal', value: 'Hiring 4 SREs · funding round Q1' },
  { label: 'Contact', value: 'Erik Lindqvist · VP Eng' },
];

const useEnrichmentLoop = () => {
  const reduced = prefersReducedMotion();
  const [phase, setPhase] = React.useState(reduced ? 'done' : 'enriching');
  const [filled, setFilled] = React.useState(reduced ? ENRICH_ROWS.length : 0);
  const [score, setScore] = React.useState(reduced ? 87 : 0);

  React.useEffect(() => {
    if (reduced) return;
    let timer;
    let alive = true;

    function cycle() {
      if (!alive) return;
      setPhase('enriching');
      setFilled(0);
      setScore(0);

      let i = 0;
      const fillNext = () => {
        if (!alive) return;
        i++;
        setFilled(i);
        if (i < ENRICH_ROWS.length) {
          timer = setTimeout(fillNext, 600);
        } else {
          timer = setTimeout(() => {
            if (!alive) return;
            setPhase('scoring');
            let s = 0;
            const target = 87;
            const tickScore = () => {
              if (!alive) return;
              s = Math.min(target, s + Math.ceil((target - s) / 6) + 1);
              setScore(s);
              if (s < target) timer = setTimeout(tickScore, 60);
              else {
                timer = setTimeout(() => {
                  if (!alive) return;
                  setPhase('done');
                  timer = setTimeout(cycle, 5000);
                }, 600);
              }
            };
            tickScore();
          }, 400);
        }
      };
      fillNext();
    }
    cycle();
    return () => { alive = false; clearTimeout(timer); };
  }, [reduced]);

  return { phase, filled, score };
};

export const LeadCRM = () => {
  const stages = [
    { t: 'New', n: 14 },
    { t: 'Outreach', n: 22 },
    { t: 'Email sent', n: 31 },
    { t: 'In discussion', n: 9 },
    { t: 'Opportunity', n: 4 },
  ];
  const { phase, filled, score } = useEnrichmentLoop();
  return (
    <div className="leadcrm">
      <div className="leadcrm__pipe">
        {stages.map((s, i) => (
          <React.Fragment key={s.t}>
            <div className="leadcrm__stage">
              <div className="leadcrm__stage-title">{s.t}</div>
              <div className="leadcrm__stage-n">{s.n}</div>
              <div className="leadcrm__stage-bar">
                <div style={{ width: `${(s.n / 31) * 100}%` }} />
              </div>
            </div>
            {i < stages.length - 1 && <div className="leadcrm__arrow">›</div>}
          </React.Fragment>
        ))}
      </div>
      <div className="lead-enrich">
        <div className="lead-enrich__card">
          <div className="lead-enrich__head">
            <div>
              <div className="lead-enrich__company">Lyra AB</div>
              <div className="lead-enrich__meta">lyra.se · Stockholm · added 2m ago</div>
            </div>
            <div className={`lead-enrich__score ${phase === 'done' ? 'is-done' : ''}`}>
              <div className="lead-enrich__score-n">{score}</div>
              <div className="lead-enrich__score-label">{phase === 'done' ? 'ICP fit' : 'scoring…'}</div>
            </div>
          </div>
          <div className="lead-enrich__rows">
            {ENRICH_ROWS.map((row, i) => {
              const visible = i < filled;
              const justAdded = i === filled - 1 && phase === 'enriching';
              return (
                <div key={row.label} className={`lead-enrich__row ${visible ? 'is-visible' : ''} ${justAdded ? 'is-fresh' : ''}`}>
                  <span>{row.label}</span>
                  <strong>
                    {visible ? row.value : (
                      <span className="lead-enrich__placeholder">
                        <span /><span /><span />
                      </span>
                    )}
                  </strong>
                </div>
              );
            })}
          </div>
          <div className="lead-enrich__foot">
            <span className="lead-enrich__by">
              {phase === 'enriching' && (<><span className="lead-enrich__spin" /> agent <code>research-prospect</code> working…</>)}
              {phase === 'scoring' && (<><span className="lead-enrich__spin" /> scoring against ICP…</>)}
              {phase === 'done' && (<>✓ enriched by <code>research-prospect</code> agent</>)}
            </span>
            <span className="lead-enrich__time">{phase === 'done' ? '3.4s' : '...'}</span>
          </div>
        </div>
        <div className="lead-enrich__copy">
          <div className="section__label" style={{ marginBottom: 12 }}>Built-in enrichment</div>
          <h3 className="lead-enrich__title">Every new lead, researched <em>before</em> you open it.</h3>
          <p>
            When a lead enters the board, an AI agent pulls company data, headcount, funding, tech-stack, and live hiring signals — then scores ICP fit and writes a personalized opener. All inside jinban. No external CRM, no Apollo, no Clay glued together.
          </p>
          <ul className="lead-enrich__bullets">
            <li>One-click run, scheduled, or column-triggered</li>
            <li>Sources fully transparent — every claim links to where it came from</li>
            <li>Sandboxed in your tenant. Your prompts never leave the EU.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export const CollabPreview = () => (
  <div className="collab">
    <div className="collab__board">
      <div className="collab__col">
        <div className="collab__col-head">Active</div>
        <div className="collab__card collab__card--focus">
          <div className="collab__card-title">Voice huddle MVP</div>
          <div className="collab__card-meta">
            <span className="collab__pill collab__pill--live">● live</span>
            <span>3 in huddle</span>
          </div>
          <div className="collab__avatars">
            <span style={{ background: '#0A0A0A' }}>K</span>
            <span style={{ background: '#7b1fa2' }}>A</span>
            <span style={{ background: '#C78A05' }}>S</span>
          </div>
        </div>
        <div className="collab__card">
          <div className="collab__card-title">Apollo enrichment</div>
          <div className="collab__card-meta">2 threads</div>
        </div>
      </div>
    </div>
    <div className="collab__chat">
      <div className="collab__chat-head">
        <span>#voice-huddle-mvp</span>
        <span className="collab__chat-presence">3 online</span>
      </div>
      <div className="collab__msgs">
        <div className="collab__msg">
          <strong>Karim</strong>
          <p>Pushed the LiveKit room provisioning. Ready for Anya to wire UI.</p>
          <time>2:14</time>
        </div>
        <div className="collab__msg">
          <strong>Anya</strong>
          <p>On it. @agent draft a release note for this when it lands.</p>
          <time>2:15</time>
        </div>
        <div className="collab__msg collab__msg--ai">
          <strong>jinban agent</strong>
          <p>Drafted release note &amp; queued it on the "Review" column. <a>open card →</a></p>
          <time>2:15</time>
        </div>
      </div>
      <div className="collab__compose">
        <span>Reply…</span>
        <span className="collab__compose-mic">●</span>
      </div>
    </div>
  </div>
);

export const Integrations = () => {
  const items = [
    { name: 'HubSpot', sub: 'Optional one-way export', tag: 'optional' },
    { name: 'Apollo.io', sub: 'Optional &mdash; or use built-in enrichment', tag: 'optional' },
    { name: 'GitHub', sub: 'PRs as tasks, commit links', tag: 'native' },
    { name: 'Email', sub: 'Inbound → task or lead', tag: 'native' },
    { name: 'Webhooks', sub: 'Outbound, signed payloads', tag: 'open' },
    { name: 'REST API', sub: 'Full DRF, rate-limited', tag: 'open' },
  ];
  return (
    <div className="integrations">
      {items.map(it => (
        <div key={it.name} className="integration">
          <div className="integration__head">
            <span className="integration__name">{it.name}</span>
            <span className="integration__tag">{it.tag}</span>
          </div>
          <div className="integration__sub" dangerouslySetInnerHTML={{ __html: it.sub }} />
        </div>
      ))}
    </div>
  );
};

export const Pricing = ({ ctaUrl }) => {
  const tiers = [
    {
      name: 'Solo',
      price: '€0',
      sub: 'Per user · forever',
      blurbs: ['1 board · unlimited cards', 'AI builder, light agents', 'Email + GitHub', 'Community support'],
    },
    {
      name: 'Team',
      price: '€18',
      sub: 'Per user / month',
      featured: true,
      blurbs: ['Unlimited boards & swimlanes', 'Sprint mode + capacity', 'Voice huddles, chat, threads', 'AI lead enrichment + outreach', 'Sandboxed agents · 1k runs/mo'],
    },
    {
      name: 'Sovereign',
      price: 'Talk to us',
      sub: 'EU-resident, single-tenant',
      blurbs: ['Single-tenant K8s in Frankfurt or Paris', 'Bring-your-own-LLM (incl. Mistral)', 'SSO, SCIM, audit log export', 'SLA, DPA, dedicated support'],
    },
  ];
  return (
    <div className="pricing">
      {tiers.map(t => {
        const href = t.name === 'Sovereign' ? 'mailto:hello@jinban.ai' : (ctaUrl || '#start');
        return (
          <div key={t.name} className={`tier ${t.featured ? 'tier--featured' : ''}`}>
            {t.featured && <div className="tier__ribbon">Recommended</div>}
            <div className="tier__name">{t.name}</div>
            <div className="tier__price">{t.price}</div>
            <div className="tier__sub">{t.sub}</div>
            <ul>
              {t.blurbs.map(b => <li key={b}>{b}</li>)}
            </ul>
            <a className="tier__cta" href={href}>{t.name === 'Sovereign' ? 'Contact sales' : 'Start free →'}</a>
          </div>
        );
      })}
    </div>
  );
};
